import { render, staticRenderFns } from "./provincePolicy.vue?vue&type=template&id=0eb14596&scoped=true&"
import script from "./provincePolicy.vue?vue&type=script&lang=js&"
export * from "./provincePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb14596",
  null
  
)

export default component.exports